module.exports = "/wwwroot/img/cooperation_logo_item_block.png?ver=c0414456";